import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CapacitacionesService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  index(): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Index", null, Sessions.header());
  }

  dataSource(varArgs : any = null): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/DataSource", varArgs, Sessions.header());
  }

  create(): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Create", null, Sessions.header());
  }

  store(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Store", objCapacitacion, Sessions.header());
  }

  edit(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Edit", objCapacitacion, Sessions.header());
  }

  update(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Update", objCapacitacion, Sessions.header());
  }

  delete(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Delete", objCapacitacion, Sessions.header());
  }

  showEvaluacion(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/ShowEvaluacion", objCapacitacion, Sessions.header());
  }

  storeEvaluacionTemporal(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/StoreEvaluacionTemporal", objCapacitacion, Sessions.header());
  }

  storeEvaluacion(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/StoreEvaluacion", objCapacitacion, Sessions.header());
  }

  showCertificados(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/ShowCertificados", objCapacitacion, Sessions.header());
  }

  searchReporte(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/SearchReporte", objCapacitacion, Sessions.header());
  }

  searchReporteParticipante(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/SearchReporteParticipante", objCapacitacion, Sessions.header());
  }

  fileReporteFilter(objCapacitacion : any): Observable<Blob> {
    return this.http.post<Blob>(this.baseUrl + "api/Capacitaciones/File/ReporteFilter", objCapacitacion, Sessions.headerFile());
  }

  fileReportePemex(objCapacitacion : any): Observable<Blob> {
    return this.http.post<Blob>(this.baseUrl + "api/Capacitaciones/File/ReportePemex", objCapacitacion, Sessions.headerFile());
  }

  fileReporteFilterParticipante(objCapacitacion : any, url : string): Observable<Blob> {
    return this.http.post<Blob>(this.baseUrl + "api/" + url, objCapacitacion, Sessions.headerFile());
  }

  sendEmail(objCapacitacion : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/SendEmail", objCapacitacion, Sessions.header());
  }

}